//Aqui se defiene las variables para el control y manejo de los input
export const initialFormSignUp = {
  selectDoc: "",
  typeDoc: "",
  password: "",
  email: "",
  name: "",
  date: "",
  phone: "",
  confirmPassword: "",
  social: "",
  selectCorreo:""
};

export const optionLogin = [
  { id: 1, name: 'Selección' },
  { id: 2, name: 'Cédula' },
  { id: 3, name: 'Pasaporte' },
  { id: 4, name: 'Rif - V' },
  { id: 5, name: 'Rif - J' },
  { id: 6, name: 'Gobierno' },
];
export const optionLoginEmpresa = [
  { id: 1, name: 'Selección' },
  { id: 2, name: 'Venezolano' },
  { id: 3, name: 'Juridico' },
];